import React__default from 'react';
import { Avatar } from '@deal/components';
import MessageBubble from '../../../MessageBubble/index.js';
import MessageBubbleText from '../../../MessageBubbleText/index.js';
import HeroWithImage from '../../components/HeroWithImage/index.js';
import CallToAction from '../../components/CallToAction/index.js';
import styles from './styles.css.js';
import { useFeedbackRequestBusinessMessageQuery } from './FeedbackRequestMessage.generated.js';

/**
 * Note: The consumer implementation has it's own flavor of this, it will be overriden
 * by the custom component passed in from that provider
 */

var FeedbackRequest = function FeedbackRequest(_a) {
  var message = _a.message,
      myself = _a.myself,
      richCard = _a.richCard;
  var leadId = richCard.leadId;

  var _b = useFeedbackRequestBusinessMessageQuery({
    variables: {
      leadId: leadId
    }
  }),
      data = _b.data,
      loading = _b.loading;

  if (loading) {
    return React__default.createElement(MessageBubbleText, {
      message: message,
      myself: myself
    }, "Loading...");
  } else if (data && data.lead) {
    var _c = data.lead,
        expert = _c.expert,
        category = _c.category;
    var name_1 = expert.displayName;
    var banner = category && category.contentAssets.bannerImages[0];
    var categoryName = category && category.singularDisplayName;
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(MessageBubble, {
      message: message
    }, React__default.createElement(HeroWithImage, {
      imageUrl: banner === null || banner === void 0 ? void 0 : banner.imageUrl,
      heroLabel: React__default.createElement(React__default.Fragment, null, ' ', expert.expertProfile && expert.expertProfile.profilePhoto && React__default.createElement("div", {
        className: styles.avatarContainer
      }, React__default.createElement(Avatar, {
        size: 80,
        name: name_1,
        src: expert.expertProfile.profilePhoto.url
      })), React__default.createElement("div", {
        className: styles.name
      }, name_1), React__default.createElement("div", {
        className: styles.category
      }, "Your ", categoryName, " Expert"), ' ')
    }), React__default.createElement(CallToAction, null, "Give feedback on " + expert.shortName)));
  } else {
    return React__default.createElement(MessageBubbleText, {
      message: message,
      myself: myself
    }, "Error loading message!");
  }
};

export default FeedbackRequest;
//# sourceMappingURL=index.js.map
